<script lang="ts">
	type SpinnerSize = 'sm' | 'md' | 'lg'

	interface SpinnerProps {
		size?: SpinnerSize
	}

	let { size = 'md' }: SpinnerProps = $props()

	const dotsCount = 8
	const sizeMap: Record<SpinnerSize, { radius: number; dotSize: number }> = {
		sm: { radius: 10, dotSize: 2 },
		md: { radius: 18, dotSize: 4 },
		lg: { radius: 22, dotSize: 4 }
	}

	const dots = $derived.by(() => {
		const config = sizeMap[size]
		return Array.from({ length: dotsCount }, (_, i) => {
			const angle = (i / dotsCount) * 2 * Math.PI
			const x = Math.cos(angle) * config.radius
			const y = Math.sin(angle) * config.radius
			return {
				x,
				y,
				delay: i * 0.125, // 1/8 second delay between dots
				dotSize: config.dotSize
			}
		})
	})
</script>

<div class="spinner spinner-{size}">
	{#each dots as dot}
		<div
			class="spinner-dot"
			style:left="calc(50% + {dot.x}px - {dot.dotSize}px)"
			style:top="calc(50% + {dot.y}px - {dot.dotSize}px)"
			style:width="{dot.dotSize * 2}px"
			style:height="{dot.dotSize * 2}px"
			style:animation-delay="{dot.delay}s"
		></div>
	{/each}
</div>

<style>
	.spinner {
		position: relative;
		border-radius: 50%;
		background-color: #64748b;
		display: inline-block;
	}

	.spinner-sm {
		width: 32px;
		height: 32px;
	}

	.spinner-md {
		width: 88px;
		height: 88px;
	}

	.spinner-lg {
		width: 64px;
		height: 64px;
	}

	.spinner-dot {
		position: absolute;
		border-radius: 50%;
		background-color: #ffffff;
		opacity: 0.3;
		animation: pulse 1s infinite ease-in-out;
	}

	@keyframes pulse {
		0%,
		100% {
			opacity: 0.3;
			transform: scale(0.8);
		}
		50% {
			opacity: 1;
			transform: scale(1.2);
		}
	}
</style>
